import Link from "next/link";

import { Project } from "interfaces";

import { useFetchDataFile } from "modules/data-files/api";

import * as flowConfig from "flows/clustering/config";
import {
  ClusteringProject,
  projectIsClusteringAnalysis,
} from "flows/clustering/interfaces";

const DataFileSummary = ({ project }: { project: Project }) => {
  const inputData = (project as ClusteringProject).data_files[
    flowConfig.INPUT_DATA
  ] as string;
  const { data: fileDetails } = useFetchDataFile(inputData, true);

  if (!projectIsClusteringAnalysis(project)) {
    return null;
  }

  return (
    <div className="m-1">
      <p className="mb-2">
        <span className="font-semibold">Input Data:</span>{" "}
        <Link href={`/data-files/${inputData}`}>
          <a className="text-primary-main">{fileDetails?.name || inputData}</a>
        </Link>
      </p>
    </div>
  );
};

export default DataFileSummary;
